import {
  Directive,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';

/**
 * Bug 34678: stock Kendo MultiSelect clears every chip when Esc is pressed while it holds focus
 * with its popup closed. Here Esc only ever closes the popup; a pick is removed by its chip's
 * remove button or the clear button. Kendo listens for keydown on this same host element in the
 * bubble phase, so a capture-phase listener runs first and stops the event in exactly the case
 * Kendo would clear (popup closed, something picked). Every other Esc reaches Kendo unchanged.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- pre-commit-allow: Bug 34678, attribute on the third-party kendo-multiselect element
  selector: 'kendo-multiselect[upsKeepSelectionOnEsc]',
  standalone: true,
})
export class KeepSelectionOnEscDirective implements OnInit, OnDestroy {
  private readonly host: HTMLElement = inject(ElementRef).nativeElement;
  private readonly multiselect = inject(MultiSelectComponent);

  private readonly onKeydown = (event: KeyboardEvent): void => {
    if (
      event.key === 'Escape' &&
      !this.multiselect.isOpen &&
      (this.multiselect.value?.length ?? 0) > 0
    ) {
      event.stopImmediatePropagation();
    }
  };

  ngOnInit(): void {
    this.host.addEventListener('keydown', this.onKeydown, true);
  }

  ngOnDestroy(): void {
    this.host.removeEventListener('keydown', this.onKeydown, true);
  }
}
